export function adaptFaqBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const rawItems = entry['items'] ?? entry['faqs'] ?? entry['questions'];
  const items = Array.isArray(rawItems)
    ? rawItems.map((item: Record<string, unknown>) => ({
        question: (item['question'] as string) ?? '',
        answer: (item['answer'] as string) ?? '',
      }))
    : [];

  return { items };
}
